import { legacyColors } from '~/legacyTheme';
import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    dialogActions: {
      padding: '7px 14px',
    },
    dialogClose: {
      fontSize: 14,
      padding: '3px 4px',
      textAlign: 'center',
    },
    dialogContent: {
      marginTop: 7,
      padding: '7px 14px',
    },
    titleText: {
      paddingLeft: 4,
    },
    titleIcon: {
      color: legacyColors.blue,
      paddingLeft: 4,
    },
    footerDialog: {
      padding: '10px 0',
      textAlign: 'right',
    },
    titleDiv: {
      borderTop: `3px solid ${legacyColors.blue}`,
      borderBottom: '2px solid #f2f2f5',
      padding: '12px 10px',
    },
    title: {
      fontSize: 14,
      fontWeight: 'bold',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      cursor: 'move',
    },
    backDrop: {
      color: legacyColors.white,
      zIndex: theme.zIndex.drawer + 1,
    },
    dialog: {
      boxShadow: 'none',
      minWidth: '400px',
    },
    standard: {
      background: legacyColors.white,
      color: legacyColors.blue,
    },
    error: {
      background: '#FF3300',
      color: legacyColors.white,
      border: 'none',
    },
    warning: {
      background: '#FFCC00',
      color: legacyColors.white,
      border: 'none',
    },
  };
};
